import * as React from 'react';

import {CodeBlock} from 'shells/code-block/code-block';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Modal} from 'shells/modal/modal';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

type Props = {
    embedCode: string;
};

export const EmbedPageModal = (props: Props) => {
    return (
        <Modal isOpen={true} fitHeight={true}>
            <div className='pb-32'>
                <ModalHeader>Embed this page inside an existing page</ModalHeader>
                <ModalSubheader>
                    Want to use this page as part of a larger page? Use the embed code below.
                </ModalSubheader>
                <div className='mb-16'>
                    <FlashBanner type='warning' hasBorder={true}>
                        Note: When embedding a page, all links must be set to &apos;Target: New
                        page&apos; to ensure redirects within the embedded page happen as expected.
                    </FlashBanner>
                </div>
                <CodeBlock
                    includeCopyButton={true}
                    height={150}
                    value={props.embedCode}
                    label={<div className='flex align-center'>Embed code</div>}
                    name='embedCode'
                />
            </div>
        </Modal>
    );
};
